import type * as React from 'react';
import type {DayNames, SemesterMatrix} from '../../../utils/IdCard';

type Props = {
    x: number;
    y: number;
    title: string;
    color: string;
    dayNames: DayNames;
    matrix: SemesterMatrix;
    omitRowHeader?: boolean;
};

const Matrix: React.FC<Props> = ({x, y, title, color, dayNames, matrix, omitRowHeader}: Props) => {
    return (
        <g transform={`translate(${x}, ${y})`}>
            <text
                x={200}
                y={35}
                fontSize={30}
                fontWeight='bold'
                fill={`#${color}`}
                textAnchor='middle'
            >
                {title}
            </text>

            {!omitRowHeader && (
                <>
                    <text x={200 - 60} y={80} fontSize={30} fill={`#${color}`} textAnchor='middle'>
                        {dayNames.aDay}
                    </text>
                    <text x={200 + 60} y={80} fontSize={30} fill={`#${color}`} textAnchor='middle'>
                        {dayNames.bDay}
                    </text>
                </>
            )}

            <g transform={omitRowHeader ? 'translate(0, -40)' : undefined}>
                <text x={200 - 140} y={140} fontSize={30} fill={`#${color}`} textAnchor='end'>
                    S1
                </text>
                <text x={200 - 140} y={200} fontSize={30} fill={`#${color}`} textAnchor='end'>
                    S2
                </text>

                <rect
                    x={200 - 120}
                    y={100}
                    width={120}
                    height={60}
                    fill='#c2c2c2'
                    stroke='black'
                    strokeWidth={5}
                />
                <rect
                    x={200}
                    y={100}
                    width={120}
                    height={60}
                    fill='#c2c2c2'
                    stroke='black'
                    strokeWidth={5}
                />
                <rect
                    x={200 - 120}
                    y={160}
                    width={120}
                    height={60}
                    fill='#c2c2c2'
                    stroke='black'
                    strokeWidth={5}
                />
                <rect
                    x={200}
                    y={160}
                    width={120}
                    height={60}
                    fill='#c2c2c2'
                    stroke='black'
                    strokeWidth={5}
                />

                <text x={200 - 60} y={140} fontSize={30} fill='black' textAnchor='middle'>
                    {matrix.semesterOneDayA}
                </text>
                <text x={200 + 60} y={140} fontSize={30} fill='black' textAnchor='middle'>
                    {matrix.semesterOneDayB}
                </text>
                <text x={200 - 60} y={200} fontSize={30} fill='black' textAnchor='middle'>
                    {matrix.semesterTwoDayA}
                </text>
                <text x={200 + 60} y={200} fontSize={30} fill='black' textAnchor='middle'>
                    {matrix.semesterTwoDayB}
                </text>
            </g>
        </g>
    );
};

export default Matrix;
